module.exports = __webpack_public_path__ + "img/globe.e1f122f6.svg";